import {copyText} from '@github-ui/copy-to-clipboard'

export async function copyRichText({html, plainText}: {html: string; plainText: string}): Promise<void> {
  if (typeof ClipboardItem === 'undefined' || typeof navigator.clipboard?.write === 'undefined') {
    return copyText(plainText)
  }

  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([plainText], {type: 'text/plain'}),
        'text/html': new Blob([html], {type: 'text/html'}),
      }),
    ])
  } catch {
    await copyText(plainText)
  }
}
